<template>
	<BaseThemeUiLoading mode="fullpage" />
</template>
